const hasCityName = (city: any): boolean =>
  [city?.city_name, city?.destination_city, city?.destination_name].some(
    (name) => typeof name === "string" && name.length > 0,
  );

function isItineraryEntry(entry: any): boolean {
  if (!entry || entry.isUserMessage || !Array.isArray(entry.destinationList)) return false;
  return entry.destinationList.some(
    (city: any) => hasCityName(city) && Array.isArray(city?.tripDetails) && city.tripDetails.length > 0,
  );
}

function findLatestItineraryEntry(chat: any[] | undefined): any | null {
  if (!Array.isArray(chat)) return null;
  for (let i = chat.length - 1; i >= 0; i -= 1) {
    if (isItineraryEntry(chat[i])) return chat[i];
  }
  return null;
}

export function isSelectionInChat(selection: any, chat: any[] | undefined): boolean {
  const id = selection?.id;
  if (!id || !Array.isArray(chat)) return false;
  return chat.some(
    (entry: any) =>
      entry?.id === id ||
      (Array.isArray(entry?.destinationList) && entry.destinationList.some((card: any) => card?.id === id)),
  );
}

export function isSelectionActiveInChat(selection: any, chat: any[] | undefined, chatId: string): boolean {
  if (isSelectionInChat(selection, chat)) return true;
  return !!chatId && !!selection?.id && selection?.attachedToChatId === chatId;
}

export function isSameConversation(current: any[] | undefined, next: any[] | undefined): boolean {
  if (!Array.isArray(current) || !Array.isArray(next) || current.length === 0 || next.length === 0) return false;
  return !!current[0]?.id && current[0].id === next[0]?.id;
}

export function resolveSelectionForChat(selection: any, chat: any[] | undefined, emptySelection: any): any {
  if (isSelectionInChat(selection, chat)) return selection;
  const ownItinerary = findLatestItineraryEntry(chat);
  return ownItinerary ? { ...ownItinerary, isItineraryStreaming: false } : emptySelection;
}
